import { isTruthy } from 'utility/functions';
import { isMarcatoriPage, isPrimoPianoPage } from 'lib/ssr';

interface generic {
  slug?: string;
}
type SlugFromTemplatePropsType = generic & {
  gruppoList?: Array<
    generic & {
      tipoScommessaList?: Array<generic>;
    }
  >;
};

interface SlugFromTemplateType {
  slug: string;
  isPrimoPiano?: boolean;
  isMarcatore?: boolean;
}
export const getSlugScommesseFromTemplate = (
  data: SlugFromTemplatePropsType,
  fromTipoScommessa?: boolean
): SlugFromTemplateType => {
  const result = {} as SlugFromTemplateType;

  const { slug: tSlug, gruppoList } = data ?? {};
  if (isTruthy(gruppoList?.length)) {
    let { slug: gSlug, tipoScommessaList } = (gruppoList ?? []).find((x) => !!x.slug) ?? {};

    if (fromTipoScommessa && isTruthy(tipoScommessaList?.length)) {
      let { slug: tSlug } = (tipoScommessaList ?? []).find((x) => !!x.slug) ?? {};
      result.slug = tSlug!;
    } else {
      result.slug = gSlug!;
    }
  } else {
    result.slug = tSlug!;
  }

  result.isMarcatore = isMarcatoriPage(result.slug);
  result.isPrimoPiano = isPrimoPianoPage(result.slug);

  return result;
};